// extracted by mini-css-extract-plugin
module.exports = {"daysToWatchCTA":"DaysToWatchCTA_daysToWatchCTA___OGpx","star":"DaysToWatchCTA_star__Fcz0D"};